import BulletinCreateUpdate from "features/bulletins/components/BulletinCreateUpdate";
import { ReactComponent as IconCreatePost } from "assets/images/icons/pencil-square.svg";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";
import { useDialog } from "context/DialogContext";
import PropTypes from "prop-types";

const BulletinCreateButton = ({ groupId, categoryId }) => {
  const history = useHistory();
  const { showDialog } = useDialog();

  const handleClick = () => {
    showDialog(
      <BulletinCreateUpdate groupId={ groupId }
                            categoryId={ categoryId }
                            isMarketPlace={ false }
                            onCompleted={ bulletin => history.push(bulletin.url) }/>
    );
  }

  return (
    <Button variant="secondary" onClick={ handleClick }>
      <IconCreatePost/>
      { groupId ? `Plaats nieuw groepsbericht` : `Plaats nieuw prikbordbericht` }
    </Button>
  )
}

BulletinCreateButton.propTypes = {
  groupId: PropTypes.number,
  categoryId: PropTypes.number.isRequired,
}

export default BulletinCreateButton;
